(function($) {
	$(document).ready(function() {
		$(window).on('load', function() {
			var header_el = $('.hero-header');
			var header_h = $('.hero-header').height();
			var typeOfPage = $('.single-people')

			var window_scroll = $(window).scrollTop();
			if((window_scroll == 0) && ($('body').hasClass('single-people') || $('body').hasClass('single-post'))) {
				$('html, body').animate({
			        scrollTop: header_h,
			    }, 1000);
			} else {
				return
			}
		});
	});
})(jQuery);